import * as React from 'react';

import { translate } from '~l10n/client';

import { iconSizes } from '~teacher/components/Header/ActivityStatusIcons/constants';

export const ActiveIcon = React.forwardRef<
  SVGSVGElement,
  {
    size: 'standard' | 'micro';
    className?: string;
  }
>(function ActiveIcon({ size, className }, ref) {
  const { width, height } = React.useMemo(() => iconSizes[size], [size]);

  return (
    <div className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 9 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label={translate('Live Results Active')}
        data-testid="activity-status-paused"
        ref={ref}
      >
        <g data-testid="activity-status-active">
          <circle id="oval" cx="4.5" cy="4.5" r="4.5" fill="currentColor" />
        </g>
      </svg>
    </div>
  );
});
